import { emptys } from "../data/main";

export const arrayToObject = ({
  key,
  value = false,
  erase = [],
  data,
}: {
  key: string;
  value?: string | boolean;
  erase?: Array<string>;
  data: Array<object>;
}) => {
  return (data ?? []).reduce(
    (accumulator: Record<string, object>, currentObject: any) => {
      if (emptys.includes(currentObject[key])) {
        return accumulator;
      }
      let tempObj = { ...currentObject };
      erase.forEach((e) => delete tempObj[e]);

      accumulator[currentObject[key]] =
        typeof value === "string" ? tempObj[value] : tempObj; // Use 'id' as the key
      return accumulator;
    },
    {} as Record<string, object>,
  );
};
